module.exports = __webpack_public_path__ + "img/facebook.3e0ad2e5.svg";